import React from 'react';
import { useTranslation } from 'react-i18next';
import './SettingsPages.css';
import './AboutSettings.css';

function AboutSettings() {
  const { t, i18n } = useTranslation('profile');

  const appName = process.env.REACT_APP_NAME || 'PlanGoNOW';
  const appVersion = process.env.REACT_APP_VERSION || '1.0.0';
  const appDescription =
    process.env.REACT_APP_DESCRIPTION ||
    t('profile.settings.pages.about.descriptionValue');
  const appBuildDateRaw = process.env.REACT_APP_BUILD_DATE || '';

  const formatDateForLocale = (value) => {
    if (!value) return null;
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return null;
    try {
      return new Intl.DateTimeFormat(i18n.language || 'pl-PL', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      }).format(date);
    } catch {
      return value;
    }
  };

  const appBuildDate =
    formatDateForLocale(appBuildDateRaw) ||
    t('profile.settings.pages.about.releaseDateValue');
  const currentYear = new Date().getFullYear();

  const handleOpenPrivacyPolicy = () => {
    // TODO: Otwórz politykę prywatności
    alert(t('profile.settings.pages.about.privacyPolicyAlert'));
  };

  const handleOpenTerms = () => {
    // TODO: Otwórz regulamin
    alert(t('profile.settings.pages.about.termsAlert'));
  };

  const handleReportBug = () => {
    // TODO: Otwórz formularz zgłoszenia błędu
    alert(t('profile.settings.pages.about.reportBugAlert'));
  };

  const handleContactSupport = () => {
    // TODO: Otwórz formularz kontaktu
    alert(t('profile.settings.pages.about.contactSupportAlert'));
  };

  return (
    <div className="settings-page">
      <div className="settings-page-content">
        {/* Informacje o aplikacji */}
        <div className="about-settings-section">
          <h3 className="about-settings-section-title">
            {t('profile.settings.pages.about.appInfo')}
          </h3>

          <div className="about-settings-info-item">
            <div className="about-settings-info-label">
              {t('profile.settings.pages.about.name')}
            </div>
            <div className="about-settings-info-value">
              {appName}
            </div>
          </div>

          <div className="about-settings-info-item">
            <div className="about-settings-info-label">
              {t('profile.settings.pages.about.version')}
            </div>
            <div className="about-settings-info-value">
              {appVersion}
            </div>
          </div>

          <div className="about-settings-info-item">
            <div className="about-settings-info-label">
              {t('profile.settings.pages.about.releaseDate')}
            </div>
            <div className="about-settings-info-value">
              {appBuildDate}
            </div>
          </div>

          <div className="about-settings-info-item">
            <div className="about-settings-info-label">
              {t('profile.settings.pages.about.descriptionLabel')}
            </div>
            <div className="about-settings-info-value about-settings-description">
              {appDescription}
            </div>
          </div>
        </div>

        {/* Dokumenty prawne */}
        <div className="about-settings-section">
          <h3 className="about-settings-section-title">
            {t('profile.settings.pages.about.legalDocuments')}
          </h3>

          <div className="about-settings-action-item">
            <div className="about-settings-action-content">
              <div className="about-settings-action-label">
                {t('profile.settings.pages.about.privacyPolicy')}
              </div>
              <div className="about-settings-action-description">
                {t('profile.settings.pages.about.privacyPolicyDescription')}
              </div>
            </div>
            <button
              className="about-settings-button"
              onClick={handleOpenPrivacyPolicy}
            >
              {t('profile.settings.pages.about.open')}
            </button>
          </div>

          <div className="about-settings-action-item">
            <div className="about-settings-action-content">
              <div className="about-settings-action-label">
                {t('profile.settings.pages.about.terms')}
              </div>
              <div className="about-settings-action-description">
                {t('profile.settings.pages.about.termsDescription')}
              </div>
            </div>
            <button
              className="about-settings-button"
              onClick={handleOpenTerms}
            >
              {t('profile.settings.pages.about.open')}
            </button>
          </div>
        </div>

        {/* Wsparcie */}
        <div className="about-settings-section">
          <h3 className="about-settings-section-title">
            {t('profile.settings.pages.about.support')}
          </h3>

          <div className="about-settings-action-item">
            <div className="about-settings-action-content">
              <div className="about-settings-action-label">
                {t('profile.settings.pages.about.reportBug')}
              </div>
              <div className="about-settings-action-description">
                {t('profile.settings.pages.about.reportBugDescription')}
              </div>
            </div>
            <button
              className="about-settings-button"
              onClick={handleReportBug}
            >
              {t('profile.settings.pages.about.report')}
            </button>
          </div>

          <div className="about-settings-action-item">
            <div className="about-settings-action-content">
              <div className="about-settings-action-label">
                {t('profile.settings.pages.about.contactSupport')}
              </div>
              <div className="about-settings-action-description">
                {t('profile.settings.pages.about.contactSupportDescription')}
              </div>
            </div>
            <button
              className="about-settings-button"
              onClick={handleContactSupport}
            >
              {t('profile.settings.pages.about.contact')}
            </button>
          </div>
        </div>

        {/* Footer */}
        <div className="about-settings-footer">
          <div className="about-settings-footer-copyright">
            © {currentYear} {t('profile.settings.pages.about.copyrightOwner')}
          </div>
          <div className="about-settings-footer-built">
            {t('profile.settings.pages.about.builtWith')}
          </div>
        </div>
      </div>
    </div>
  );
}

export default AboutSettings;
